import { Path } from 'enums';
import DashboardModule from 'modules/dashboard/dashboard.module';

import React from 'react';
import { Route, Switch } from 'react-router-dom';

const DashboardPage = () => {
  return (
    <Switch>
      <Route exact path={Path.Slash} component={DashboardModule} />
    </Switch>
  );
};

export default DashboardPage;
